/**
 * The sub-option chosen for a Date block set to "Date Range" mode.
 *
 * - SPECIFIC: the range comes from the block's own date-range selector (`dateQuery`).
 * - RECURRENCE: the range is derived automatically from the Briefing's recurrence
 *   schedule at send time (only available when the Briefing publishes on a recurring
 *   schedule).
 */
export enum BriefingDateRangeTypeEnum {
    SPECIFIC = 'SPECIFIC',
    RECURRENCE = 'RECURRENCE'
}

/**
 * Placeholder rendered in the draft for a Date block set to "Based on Recurrence Date Range".
 * The actual range isn't known until send time, so the draft shows this token and the backend
 * resolves it from the Briefing's recurrence schedule when the Briefing is sent.
 */
export const RECURRENCE_DATE_RANGE_PLACEHOLDER = '[%Recurrence_Date_Range%]';
